import React from "react";
const NickNameBadge = ({badge = {}}) => {
    const display = (badge.is_manager || badge.is_top_fan || badge.is_fan || badge.is_support || badge.is_subscribe) ? true: false;
    return(
        display && (
            <div className="badge">
                {badge.is_manager ? <em className="ic-manager">매니저</em> : ''}
                {!badge.is_manager && badge.is_top_fan ? <em className="ic-hot">열혈팬</em> : ''}
                {!badge.is_manager && badge.is_subscribe ? <em className="ic-sub">구독팬</em> : ''}
                {!badge.is_manager && !badge.is_top_fan && badge.is_fan ? <em className="ic-fan">팬클럽</em> : ''}
                {!badge.is_manager && badge.is_support ? <em className="ic-support">서포터</em> : ''}
            </div>
        )
    );
};

export default NickNameBadge;